export default {"src":"/_next/static/media/verified-icon.a476d11b.svg","height":12,"width":12};